import { render, staticRenderFns } from "./PdfBarsWrapper.vue?vue&type=template&id=2617e501"
import script from "./PdfBarsWrapper.vue?vue&type=script&lang=js"
export * from "./PdfBarsWrapper.vue?vue&type=script&lang=js"
import style0 from "./PdfBarsWrapper.vue?vue&type=style&index=0&id=2617e501&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports